<template>
	<div
		v-if="isShowOpenState"
		class="venue-open-state"
		:class="elementSize && `venue-open-state--${elementSize}`"
	>
		<div class="icon-holder">
			<img
				:src="icons.foodIcon"
				class="venue-open-state__icon"
				alt="Food image"
			/>
		</div>
		{{ venueOpenStateText }}
	</div>
</template>

<script>
import availabilityTime from '@/mixins/availabilityTime'
import FoodIcon from '@/assets/images/ic_food.svg'
import { getAmPmTime } from '@/utils/helpers'
import { mapState } from 'vuex'

export default {
	name: 'VenueOpenState',

	props: {
		elementSize: {
			type: String,
			default: ''
		}
	},

	mixins: [availabilityTime],

	computed: {
		...mapState('ui', ['isDesktopDevice']),
		...mapState({
			cart: state => state.cart,
			venueInfo: state => state.venue.venueInfo
		}),

		icons() {
			return { foodIcon: FoodIcon }
		},

		acceptOnlineOrder() {
			return this.venueInfo.acceptOnlineOrder
		},

		isPickUpExist() {
			return this.pickUpHours && this.pickUpHours.length
		},

		startPickUp() {
			return this.isPickUpExist && this.pickUpHours[0].startTime
		},

		endPickUp() {
			return this.isPickUpExist && this.pickUpHours[0].endTime
		},

		isForHereExist() {
			return this.forHereHours && this.forHereHours.length
		},

		startForHere() {
			return this.isForHereExist && this.forHereHours[0].startTime
		},

		endForHere() {
			return this.isForHereExist && this.forHereHours[0].endTime
		},

		isInVenue() {
			return this.cart.isInVenue
		},

		isPickUp() {
			return this.cart.isPickUp
		},

		isShowOpenState() {
			if (!this.acceptOnlineOrder) {
				return false
			}

			if (this.isDesktopDevice) {
				return this.isPickUpExist
			} else {
				return this.isPickUpExist || this.isForHereExist
			}
		},

		venueOpenStateText() {
			if (
				(this.isDesktopDevice && this.isPickUpExist) ||
				(!this.isDesktopDevice && this.isPickUp)
			) {
				return this.pickUpStatus
			} else if (!this.isDesktopDevice && this.isInVenue) {
				return this.forHereStatus
			}

			return null
		},

		pickUpStatus() {
			const endTime = getAmPmTime(this.endPickUp, 'h:mm a')?.toUpperCase() || ''
			const startTime =
				getAmPmTime(this.startPickUp, 'h:mm a')?.toUpperCase() || ''

			if (this.isPickUpOrderingAvailable) {
				return `Open for Pickup till ${endTime}`
			}

			if (!this.isPickUpOrderingAvailable && this.isPickUpExist) {
				return `Open for Pickup from ${this.getDayName(
					this.pickUpHours[0].dow
				)} ${startTime}`
			}

			return ''
		},

		forHereStatus() {
			const endTime =
				getAmPmTime(this.endForHere, 'h:mm a')?.toUpperCase() || ''
			const startTime =
				getAmPmTime(this.startForHere, 'h:mm a')?.toUpperCase() || ''

			if (this.isForHereOrderingAvailable) {
				return `Open for Dine in till ${endTime}`
			}

			if (
				!this.isForHereOrderingAvailable &&
				this.isForHereNotAvailableNowAndAvailableToday
			) {
				return `Open for Dine in from ${startTime}`
			}

			if (
				!this.isForHereOrderingAvailable &&
				!this.isForHereNotAvailableNowAndAvailableToday &&
				this.isForHereExist
			) {
				return `Open for Dine in from ${this.getDayName(
					this.forHereHours[0].dow
				)} ${startTime}`
			}

			return ''
		}
	}
}
</script>

<style lang="scss" scoped>
@import './src/assets/styles/variables';

.venue-open-state {
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 2px;
	padding: 6px;
	border: 1px solid rgba($white, 0.5);
	border-radius: 12px;
	text-align: center;
	font-size: 14px;
	background: rgba($blue-faceless-void, 0.25);
	&__icon {
		width: 22px;
		height: 22px;
		margin-right: 8px;
	}
	&--sm {
		padding: 5px 15px;

		.venue-open-state__icon {
			width: 15px;
			height: 15px;
			margin-right: 5px;
		}
	}
}
</style>
